<template>
  <div>
    <el-row class="title-bar">
      <el-col :span="6">
        <h3>스마트 추적</h3>
      </el-col>
      <el-col :span="18" class="btn-group-right">
        <el-button type="primary" size="mini" :disabled="hiddenFlowHistButton" @click="onClickHistButton"> 과거이력조회 </el-button>
        <el-button type="content" class="prefix reset" size="mini" @click="onClickRefreshButton">초기화</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="5" @mouseover.native="onMouseOverSmartTrace" @mouseleave.native="onMouseLeaveSmartTrace">
      <el-button class="smart-button" style="left: 0px" type="no-border" v-show="showLeftButton" @click="onClickLeftButton"><i class="fas fa-chevron-left" /></el-button>

      <el-col :lg="6" :md="12" v-for="(number, idx) in 4" :key="number">
        <w-smart-trace-component ref="smartTraceCmp" :flow-params="smartTraceParams" :card-type="getCardType(idx)" :first-card-type="firstCardType" :analysis-type="analysisType" :selected-trace-filter="smartTraceFilter"
        :selected-items="selectedItemList" @selectItem="onSelectItem">
          <span slot="title" v-if="idx !== firstCardIndex">
            {{ getCardInfo(idx).label }}
          </span>
          <el-select class="custom-input-mini" slot="title" v-if="idx === firstCardIndex" v-model="firstCardType">
            <el-option v-for="type in cardType" :key="type.value" :label="type.label" :value="type.value" />
          </el-select>

          <span slot="number">{{ number + traceIndex }}</span>
        </w-smart-trace-component>
      </el-col>

      <el-button class="smart-button" style="right: 0px" type="no-border" v-show="showRightButton" @click="onClickRightButton"><i class="fas fa-chevron-right" /></el-button>
    </el-row>

    <!-- 과거이력조회 팝업창 -->
    <w-flow-hist-popup ref="flowHistPopup" :flow-params="flowParams" :smart-trace-filter-list="smartTraceFilterList"/>
  </div>
</template>

<script>
import clone from 'lodash/clone';
import findIndex from 'lodash/findIndex';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import unionBy from 'lodash/unionBy';
import WSmartTraceComponent from './SmartTraceComponent';
import WFlowHistPopup from '../popup/FlowHistPopup';

export default {
  name: 'WSmartTraceView',
  components: {
    WSmartTraceComponent,
    WFlowHistPopup,
  },
  props: {
    /**
     * 추이차트 분석 타입
     * @type {Boolean}
     */
    analysisType: String,
    /**
     * 추이 차트 데이터 조회할 때마다 로드할 수 있도록 한다.
     * @type {[type]}
     */
    flowParams: Object,
  },
  data() {
    return {
      firstCardType: 'ipaddress',
      cardType: [{ label: 'IP', value: 'ipaddress' }, { label: '프로토콜', value: 'protocol' }, { label: 'Conversation', value: 'conversation' }, { label: '서비스 포트', value: 'port' }],
      traceMethod: {
        ipaddress: [{ label: '프로토콜', value: 'protocol' }, { label: 'Conversation', value: 'conversation' }, { label: '서비스 포트', value: 'port' }],
        conversation: [{ label: 'IP', value: 'ipaddress' }, { label: '프로토콜', value: 'protocol' }, { label: '서비스 포트', value: 'port' }],
        protocol: [{ label: 'IP', value: 'ipaddress' }, { label: 'Conversation', value: 'conversation' }, { label: '서비스 포트', value: 'port' }],
        port: [{ label: 'IP', value: 'ipaddress' }, { label: '프로토콜', value: 'protocol' }, { label: 'Conversation', value: 'conversation' }],
      },
      hoverFlag: false,
      traceIndex: 0,
      cardList: [],
      smartTraceFilterList: [],
      smartTraceFilter: {},
      smartTraceParams: {},
      selectedItemList: [],
    };
  },
  computed: {
    typeIsNetdevice() {
      return this.analysisType === 'netdevice';
    },
    showLeftButton() {
      return this.typeIsNetdevice && this.hoverFlag && this.traceIndex > 0;
    },
    showRightButton() {
      return this.typeIsNetdevice && this.hoverFlag && this.traceIndex < 1;
    },
    firstCardIndex() {
      return this.cardList.length > 3 ? 1 - this.traceIndex : 0;
    },
    hiddenFlowHistButton() {
      return this.smartTraceFilterList.length < 1;
    },
  },
  watch: {
    /**
     * [장비별 분석]일 경우 스마트 추적은 5개(인터페이스 추가)
     * 나머지 분석일 경우 스마트 추적 4개 컴포넌트(IP, 프로토콜, conversation, 서비스 포트)
     * @param  {[type]}  type [description]
     * @return {Boolean}      [description]
     * @author jda
     */
    analysisType: {
      immediate: true,
      handler() {
        this.traceIndex = 0;
        this.selectedItemList = [];

        const baseCardList = clone(this.traceMethod[this.firstCardType]);
        if (this.typeIsNetdevice) {
          baseCardList.unshift({ label: '인터페이스', value: 'netinterface' });
        }
        this.cardList = baseCardList;
      },
    },
    /**
     * 첫 번째 카드의 타입이 바뀔때 마다 스마트 추적 리스트 재설정.
     * @param  {[type]} type [description]
     * @return {[type]}      [description]
     * @author jda
     */
    firstCardType(type) {
      const baseCardList = clone(this.traceMethod[type]);
      if (this.typeIsNetdevice) {
        baseCardList.unshift({ label: '인터페이스', value: 'netinterface' });
      }
      this.cardList = baseCardList;
    },
    flowParams(params) {
      if (isEmpty(params)) {
        this.smartTraceParams = {};
        return;
      }

      this.setSmartTraceParams();
    },
  },
  methods: {
    /**
     * 스마트 추적 카드의 정보를 반환한다.
     * @param  {[type]} idx [description]
     * @return {[type]}     [description]
     * @author jda
     */
    getCardInfo(idx) {
      let index = 0;

      // [장비별 분석]에서 [>]버튼 클릭 시
      if (this.traceIndex > 0) {
        index = idx;
      } else {
        index = idx < this.firstCardIndex ? idx : idx - 1;
      }
      return this.cardList[index];
    },
    /**
     * [스마트 추적] 컴포넌트 mouseover event
     * @return {[type]} [description]
     * @author jda
     */
    onMouseOverSmartTrace() {
      this.hoverFlag = true;
    },
    /**
     * [스마트 추적] 컴포넌트 mouseleave event
     * @return {[type]} [description]
     * @author jda
     */
    onMouseLeaveSmartTrace() {
      this.hoverFlag = false;
    },
    /**
     * [장비별 분석]일 경우 [>]버튼 클릭 시 다음 스마트 추적 카드가 표현된다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickRightButton() {
      this.traceIndex = this.traceIndex + 1;
      this.setSelectedItems();
    },
    /**
     * [장비별 분석]일 경우 [<]버튼 클릭 시 이전 스마트 추적 카드가 표현된다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickLeftButton() {
      this.traceIndex = this.traceIndex - 1;
      this.setSelectedItems();
    },
    /**
     * 스마트 추적 card 구분을 반환한다.
     * @param  {[type]} idx [description]
     * @return {[type]}     [description]
     * @author jda
     */
    getCardType(idx) {
      if (idx === this.firstCardIndex) {
        return this.firstCardType;
      }
      return this.getCardInfo(idx).value;
    },
    /**
     * 1. 스마트 추적 초기화 버튼 클릭시 카드들을 재로드한다.
     * 2. 장비별 분석일 경우 [인터페이스]카드가 맨 앞에 위치한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickRefreshButton() {
      if (isEmpty(this.flowParams)) {
        return;
      }
      this.selectedItemList = [];

      if (this.analysisType === 'netdevice' && this.traceIndex > 0) {
        this.traceIndex = 0;

        const baseCardList = clone(this.traceMethod[this.firstCardType]);
        baseCardList.unshift({ label: '인터페이스', value: 'netinterface' });
        this.cardList = baseCardList;
        // this.smartTraceFilter = {};
      } else {
        this.$refs.smartTraceCmp.forEach((cmp) => {
          cmp.smartTraceFilter = {};
          cmp.resetSelectedItem();
          cmp.loadData();
        });
      }
    },
    /**
     * 순서대로 배치된 카드의 항목을 먼저 선택해야한다.
     * 이전의 카드의 항목을 선택 해제하면 그 이후의 카드 항목은 리셋되어야 한다.
     * @param  {[type]} currentCmp [description]
     * @return {[type]}            [description]
     * @author jda
     */
    onSelectItem(currentCmp, type) {
      const smartTraceCmpList = clone(this.$refs.smartTraceCmp);
      const currentIdx = findIndex(smartTraceCmpList, currentCmp);
      const currentItem = currentCmp.selectedItem;
      const analysisType = this.analysisType;
      let smartTraceFilterList = [];

      for (let i = 0; i < 4; i += 1) {
        const compareItem = clone(smartTraceCmpList[i].selectedItem);
        // 항목을 선택할 경우
        if (currentItem.selected) {
          if (i < currentIdx && !compareItem.selected) {
            // 전의 카드가 선택 되지 않을 경우 현재 카드의 항목 선택을 막는다.
            smartTraceCmpList[currentIdx].resetSelectedItem();
          } else if (i > currentIdx && compareItem.selected && analysisType !== 'netdevice') {
            // 1. 이후의 카드가 선택되어 있을 경우 모두 리셋한다.
            // 2. 현재 카드의 선택 항목을 바꿨을 경우 이후의 카드를 모두 리셋한다.
            smartTraceCmpList[i].resetSelectedItem();
          }
        } else if (!currentItem.selected) {
          // 항목 선택을 해제 할 경우
          if (i > currentIdx && compareItem.selected) {
            smartTraceCmpList[i].resetSelectedItem();
          } else if (i < currentIdx && compareItem.selected && type !== 'trace' && analysisType !== 'netdevice') {
            // 스마트 추적 항목 선택으로 인한 재로드시 이전의 카드를 리셋한다.
            smartTraceCmpList[i].resetSelectedItem();
          }
        }

        // 스마트 추적 필터 데이터 가공
        const selectedItem = clone(smartTraceCmpList[i].selectedItem);
        if (selectedItem.selected) {
          smartTraceFilterList.push({
            selected: true,
            cardType: smartTraceCmpList[i].cardType,
            type: smartTraceCmpList[i].smartTraceFilterType,
            name: selectedItem.name,
            itemId: selectedItem.itemId,
          });
        }
      }

      if (!isEqual(this.smartTraceFilterList, smartTraceFilterList)) {
        let smartTraceFilter = {};
        smartTraceFilterList.forEach((item) => {
          smartTraceFilter[item.type] = item.itemId;
        });

        // [장비별 분석] 스마트 추적 이동이 있었을 경우
        if (this.analysisType === 'netdevice' && !isEmpty(this.selectedItemList)) {
          const netdeviceSmartTraceFilter = {};
          this.selectedItemList.forEach((item) => {
            netdeviceSmartTraceFilter[item.type] = item.itemId;
          });
          smartTraceFilter = Object.assign({}, netdeviceSmartTraceFilter, smartTraceFilter);
          smartTraceFilterList = unionBy([this.selectedItemList[0]], smartTraceFilterList, 'type');
        }
        this.smartTraceFilter = smartTraceFilter;
        this.smartTraceFilterList = smartTraceFilterList;

        // 트래픽 목록의 smartTraceFilter를 emit함.
        this.$emit('setSmartTraceFilter', smartTraceFilterList);
      }
    },
    /**
     * flow추이차트 파라메터 + 스마트 추적 선택 항목 파라메터 가공
     * @author jda
     */
    setSmartTraceParams() {
      // 스마트 추적 필터 파라메터 초기화
      this.smartTraceFilter = {};

      const smartTraceFilter = this.smartTraceFilter;
      const requestParamVO = Object.assign({}, this.flowParams.requestParamVO, { smartTraceFilter });
      this.smartTraceParams = Object.assign({}, this.flowParams, { requestParamVO });
    },
    /**
     * 과거  Flow 이력 조회 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickHistButton() {
      this.$refs.flowHistPopup.open();
    },
    /**
     * [장비별 분석]일 경우 선택된 항목들을 유지.
     * @author jda
     */
    setSelectedItems() {
      const selectedItemList = [];
      this.$refs.smartTraceCmp.forEach((cmp) => {
        const item = cmp.selectedItem;
        if (item.selected) {
          selectedItemList.push(item);
        }
      });

      if (!isEmpty(this.selectedItemList)) {
        this.selectedItemList = unionBy([this.selectedItemList[0]], selectedItemList, 'type');
      } else {
        this.selectedItemList = selectedItemList;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.smart-button {
  display: flex;
  position: absolute;
  z-index: 1;
  top: 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/FlowAnalysis/components/view/SmartTraceView.vue